/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_TueInputs */

const en_ui_day_tue = /** @type {(inputs: Ui_Day_TueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue`)
};

const de_ui_day_tue = /** @type {(inputs: Ui_Day_TueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di`)
};

/**
* | output |
* | --- |
* | "Tue" |
*
* @param {Ui_Day_TueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_tue = /** @type {((inputs?: Ui_Day_TueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_TueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_tue(inputs)
	return de_ui_day_tue(inputs)
});